import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_SourceItem = _resolveComponent("SourceItem")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#chat",
    min_width: $options.size,
    max_width: $options.size,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Sources (" + _toDisplayString($props.sources.length) + ") ", 1 /* TEXT */),
        _createVNode(_component_Icon, {
          class: "close-btn pointer",
          icon: "x",
          "stroke-width": "0.2",
          stroke: "var(--gray-600)",
          size: "2rem",
          onClick: $options.close
        }, null, 8 /* PROPS */, ["onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_ScrollBar, {
        class: "scrollbar",
        "bar-x-offset": "-1rem",
        fade: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sources-wrapper", {one: $props.sources.length === 1}])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sources, (source, idx) => {
              return (_openBlock(), _createBlock(_component_SourceItem, {
                key: idx,
                class: "source",
                source: source
              }, null, 8 /* PROPS */, ["source"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["min_width", "max_width", "onClickOutside"]))
}